/**
 * Created by oronm on 15/09/2016.
 */

import linkTag from './LinkTag';

function lookForMedia(content) {
  return content.indexOf('img') === -1 && content.indexOf('iframe') === -1;
}

function generateLabels(labels) {
  const links = [];
  for (let i = 0; i < labels.length; i++) {
    const singleLabel = labels[i];
    if (typeof singleLabel.name !== 'undefined') {
      links.push(linkTag(singleLabel));
    }
  }
  return links;
}


function getMonth(date) {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[date.getMonth()];
}

function generateDate(timestamp) {
  const tempDate = new Date(timestamp);
  return {
    month: getMonth(tempDate),
    day: tempDate.getDate(),
    year: tempDate.getFullYear()
  };
}

const article = (article, index) => {
  return {
    title: article.title,
    index,
    id: article.id,
    content: article.content,
    date: generateDate(article.creationDate),
    links: generateLabels(article.labels),
    withoutMedia: lookForMedia(article.content)
  };
};

module.exports = article;



// WEBPACK FOOTER //
// ./Modules/Article.js